module.exports = __webpack_public_path__ + "static/media/Le-Thi-Lan.b9fe75af.png";